import src from "IMAGE";
export default { src, width: 1500, height: 6100, blurWidth: 2, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAICAYAAADTLS5CAAAANklEQVR42iWLUQoAMAhCBXeWqCi6/+0214+IzwczY1UREcHMJNydM3Mg9BdFd+/yyn4+kiX9AiPmCAqLSfQIAAAAAElFTkSuQmCC"};
